/* UNSPOKEN gallery sync.
   The main product image follows the chosen finish and box. Every slide carries
   data-combo, written from the media alt text, so the match is data rather than a
   hardcoded index. If no photo exists for a combination the current image is left
   alone rather than showing the wrong box.

   This also runs once on load: an ad can land on ?variant=... for a combination
   that is not the lead photo, and the image has to agree with the price from the
   first frame, not only after a tap. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function comboFrom(values) {
    if (values.length < 2 || !values[0] || !values[1]) return null;
    var finish = /white/i.test(values[0]) ? 'White Gold'
               : /yellow/i.test(values[0]) ? 'Yellow Gold' : null;
    if (!finish) return null;
    return finish + ', ' + values[1];
  }

  function init(root) {
    var gal = root.querySelector('[data-un-gallery]');
    var main = root.querySelector('[data-un-main]');
    if (!gal || !main) return;

    var slides = gal.querySelectorAll('.un-gal__slide');
    var catalogue = Array.prototype.map.call(slides, function (s) {
      var im = s.querySelector('img');
      return {
        combo: s.getAttribute('data-combo') || '',
        src: im.getAttribute('src'),
        srcset: im.getAttribute('srcset') || '',
        alt: im.getAttribute('alt') || ''
      };
    });
    var rows = root.querySelectorAll('.un-opt__row');
    if (!rows.length) return;

    function apply(entry, animate) {
      if (!entry || entry.src === main.getAttribute('src')) return;
      var set = function () {
        main.setAttribute('src', entry.src);
        if (entry.srcset) main.setAttribute('srcset', entry.srcset);
        main.setAttribute('alt', entry.alt);
        gal.querySelector('.un-gal__slide').setAttribute('data-combo', entry.combo);
        main.style.opacity = '';
      };
      if (reduce || !animate) { set(); return; }
      main.style.transition = 'opacity 140ms ease';
      main.style.opacity = '0';
      window.setTimeout(set, 140);
    }

    function swap(animate) {
      var vals = [];
      rows.forEach(function (r) {
        var hit = r.querySelector('input:checked');
        vals.push(hit ? hit.value : null);
      });
      var want = comboFrom(vals);
      if (!want) return;
      for (var i = 0; i < catalogue.length; i++) {
        if (catalogue[i].combo === want) { apply(catalogue[i], animate); return; }
      }
      /* nothing matches this combination: hold the current image */
    }

    root.querySelectorAll('.un-opt__row input').forEach(function (i) {
      i.addEventListener('change', function () { swap(true); });
    });
    swap(false);
  }

  function boot() {
    document.querySelectorAll('[data-un-product]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
